export type EditorMediaUploadField = "media" | "gatedMedia";

export const getEditorMediaUploadField = ({
  activeTab,
  isGated = true,
  lastFocusedField,
}: {
  activeTab?: string | null;
  isGated?: boolean;
  lastFocusedField?: string | null;
}): EditorMediaUploadField => {
  if (!isGated || activeTab === "body") {
    return "media";
  }

  if (activeTab === "gatedBody" || lastFocusedField === "gatedBody") {
    return "gatedMedia";
  }

  return "media";
};
